import useGoto from '~/hooks/use-goto';
import SmartActions from '~/apps/smartsend/components/smart-actions/smart-actions';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { useCallback, useMemo } from 'react';
import { ConcernType } from '~/apps/smartsend/components/concerns/Concern';

type props = {
  isXs: boolean;
  wrapper: (children: React.ReactNode) => React.ReactNode;
  limitToConcernTypes?: ConcernType[];
  contained: boolean;
};

export const NavSmartActions = ({ isXs, wrapper, limitToConcernTypes, contained }: props) => {
  const { goTo } = useGoto();

  const actions = useMemo(() => {
    return {
      SmartSendActionFirstParcelSent: () => {
        goTo(RoutingConstants.SmartSend);
      },
      SmartSendSetupAccountScreen: () => {
        goTo(RoutingConstants.AccountLinking);
      },
      SmartSendSetupCollectionAddressScreen: () => {
        goTo(RoutingConstants.SmartSend);
      }
    };
  }, [goTo]);

  const onSend = useCallback(() => {
    goTo(RoutingConstants.SmartSend);
  }, [goTo]);

  const onFix = useCallback(() => {
    goTo(RoutingConstants.SmartSend);
  }, [goTo]);

  return (
    <SmartActions
      isXs={isXs}
      send={onSend}
      fix={onFix}
      onAchievementClick={actions}
      wrapper={wrapper}
      limitToConcernTypes={limitToConcernTypes}
      contained={contained}
    />
  );
};
